import { render, staticRenderFns } from "./viewPoint.vue?vue&type=template&id=c52f638e&scoped=true"
import script from "./viewPoint.vue?vue&type=script&lang=js"
export * from "./viewPoint.vue?vue&type=script&lang=js"
import style0 from "./viewPoint.vue?vue&type=style&index=0&id=c52f638e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52f638e",
  null
  
)

export default component.exports